var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ml-2"},[_c('v-icon',{attrs:{"small":"","color":_vm.sheet.product_color}},[_vm._v("mdi-circle")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }